import React from 'react';
import { defaultTo } from 'lodash';
import formatters from "../../../utils/forms/formatters";

const {USDCurrency: {formatter: USDformatter}} = formatters



function ProjectCard({ project= {}, header, children=(<></>) }) {

    let improvements = project?.improvements || []

    return (
        <div className="card">
            {header}
            <div className="card-content">
                <div className="content">
                    <div>
                        <div className="title is-size-4 has-text-primary">{project.project_name}</div>
                        {/* {!!project.project_name && (project.project_name !== project?.searched_address) && */}
                            <div className="subtitle is-size-5">{project?.address?.formatted_address}</div>
                        {/* } */}
                    </div>
                    <div className="columns mt-4">
                        <div className="column">
                            {improvements.map(d => (
                                    d.name ? <p className="has-text-grey my-0 " key={d.name}>{d.name}: {USDformatter(d.value)}</p> : null
                            ))}
                            <div className="mt-2">
                            {!!(project?.tax_benefits_available && !['absorb', 'direct_pay', 'long_term'].includes(project.tax_benefit_request)) &&
                                <p className="has-text-grey-dark has-text-weight-semibold my-0">
                                    Estimated Tax Contribution: {USDformatter(project.tax_benefits_available)}
                                </p>
                            }
                            {!!(project?.direct_pay_amount) &&
                                <p className="has-text-grey-dark has-text-weight-semibold my-0">
                                    US Gov Direct Pay: {USDformatter(project.direct_pay_amount)}
                                </p>
                            }
                            <p className="has-text-primary has-text-weight-semibold my-0">
                                Financed: {USDformatter(project.amount || improvements.reduce((r,d) => r + (+d.value || 0), 0))} +
                                Points and Fees*
                            </p>
                            </div>
                            {children}
                        </div>
                    </div>
                </div>
            </div>


        </div>
    )

}


export default ProjectCard;